import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import DisplayBox from '@client/components/displayBox/DisplayBox';
import SectionTitle from '@client/components/texts/SectionTitle';
import { COLORS } from '@client/shared/js/Colors';
import { strings } from '@client/localization/Localization';
import 'react-dynamic-swiper/lib/styles.css';
import Slideshow from '@client/components/swiper/Slideshow';
import { episodeRoute } from '@client/pages/routes';
import { ROUTES } from '@client/pages/routes';
import indicators from '@client/shared/js/indicators';
import styles from './featuredEpisodesSection.scss';

class FeaturedEpisodesSection extends PureComponent {
  navigateTo = (link) => {
    this.props.history.push(link);
  };

  backgroundLineEffect = () => {
    if (this.props.backgroundLines) {
      return <div className={styles.extraBackground} />;
    }
  };

  render() {
    const { className, episodes = [], sectionTitle } = this.props;
    if (episodes.length === 0) {
      return null;
    }
    return (
      <>
        <div
          className={
            className
              ? `${styles.featuredEpisodesSection} ${className}`
              : styles.featuredEpisodesSection
          }
        >
          <div className={styles.contentWrapper}>
            <SectionTitle
              className={styles.sectionTitle}
              title={sectionTitle}
              linkText={strings.allEpisodes}
              linkColor={COLORS.colorWhite}
              onLinkClick={() => this.navigateTo(ROUTES.episodes)}
            />
            <Slideshow
              className={styles.slideShow}
              componentid="featuredepisodesslider"
              options={{
                spaceBetween: 25,
                slidesPerView: 3,
                loop: episodes.length > 3,
                breakpoints: {
                  1024: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },
                  768: {
                    slidesPerView: 1.8,
                    spaceBetween: 10,
                  },
                  565: {
                    slidesPerView: 1.3,
                    spaceBetween: 10,
                  },
                },
                containerModifierClass: 'factuals-slideshow-container-',
              }}
              items={
                episodes &&
                episodes.map((episode) => {
                  return {
                    itemKey: episode.id,
                    component: (
                      <DisplayBox
                        key={episode.id}
                        title={episode.title}
                        imgSrc={episode.thumbnailImageUrl}
                        alt={episode.title}
                        categoryTitle={episode.categoryTitle}
                        categoryColor={episode.categoryColor}
                        sponsor={episode.sponsor}
                        whiteTitle={true}
                        route={episodeRoute(episode.slug, episode.seriesSlug)}
                      />
                    ),
                  };
                })
              }
            />
            <div className={styles.sliderNav}>
              <img
                onClick={function() {
                  document
                    .getElementById('prev-featuredepisodesslider')
                    .click();
                }}
                className={styles.prevButton}
                style={{ display: episodes.length <= 3 ? 'none' : undefined }}
                src={indicators.play_icon_white}
                alt="Previous Slide"
              />
              <img
                onClick={function() {
                  document
                    .getElementById('next-featuredepisodesslider')
                    .click();
                }}
                className={styles.nextButton}
                style={{ display: episodes.length <= 3 ? 'none' : undefined }}
                src={indicators.play_icon_white}
                alt="Next Slide"
              />
            </div>
          </div>
        </div>
        {this.backgroundLineEffect()}
      </>
    );
  }
}

FeaturedEpisodesSection.propTypes = {
  className: PropTypes.string,
  sectionTitle: PropTypes.string,
  episodes: PropTypes.array,
  history: PropTypes.object,
  backgroundLines: PropTypes.bool,
};

export default withRouter(FeaturedEpisodesSection);
